module.exports = __webpack_public_path__ + "static/media/erlang.8d7d2212.svg";